import { BankOperationsListComment } from 'pages/Finance/BankOperations/BankOperationsList/BankOperationsListComment/BankOperationsListComment';
import { BankOperationCommentsSkeleton } from 'pages/Finance/BankOperations/components/BankOperationCommentsSkeleton';
import { useBankOperationComments } from 'pages/Finance/BankOperations/hooks/useBankOperationComments';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { BankOperation } from 'types/embedded/bankOperation';

export const BankOperationsShowTabsComments: React.FC = () => {
  const record = useRecordContext<BankOperation>();
  const { comments, isLoading } = useBankOperationComments(record?.originId);

  if (isLoading) {
    return <BankOperationCommentsSkeleton />;
  }

  return comments.length ? (
    <Box display="flex" flexDirection="column" gap="8px">
      {comments.map((comment) => (
        <RecordContextProvider key={comment.id} value={comment}>
          <BankOperationsListComment />
        </RecordContextProvider>
      ))}
    </Box>
  ) : (
    <Alert severity="info">Комментарии отсутствуют</Alert>
  );
};
